import { Metadata } from "../models/metadata.model";
import { SourceItem } from "../models/source-item.model";

export function mapMetadataToItem(metadata: Metadata): SourceItem {
    const item: SourceItem = {
        value: metadata._id?.str || "",
        props: {
            system: {
                path: [metadata.path],
            }
        },
    }
    metadata.autoSnippet && (item.props.system.autoSnippet = [metadata.autoSnippet]);
    metadata.autoSummary && (item.props.system.autoSummary = [metadata.autoSummary]);
    metadata.category && (item.props.system.category = [metadata.category]);
    metadata.edition && (item.props.system.edition = [metadata.edition]);
    metadata.height && (item.props.system.height = [metadata.height]);
    metadata.lang && (item.props.system.lang = [metadata.lang]);
    metadata.microcontent && (item.props.system.microcontent = [metadata.microcontent]);
    metadata.lastModified && (item.props.system.modified = [metadata.lastModified]);
    metadata.title && (item.props.system.title = [metadata.title]);
    metadata.type && (item.props.system.type = [metadata.type]);
    metadata.mediaType && (item.props.system.mediaType = [metadata.mediaType]);
    metadata.properties && (item.props.custom = metadata.properties);
    metadata.validity && (item.validity = metadata.validity);
    metadata.width && (item.props.system.width = [metadata.width]);
    if (metadata.chunkDefinitions && metadata.chunkDefinitions.length >= 1) {
        const def = metadata.chunkDefinitions[0];
        item.props.chunk = {
            id: [def._id?.str ?? ""],
            index: [def.index],
        };
    }
    return item;
}
